import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import PackageUploader from './uploader.vue';
import { stageOptions } from '@/common/material-metadata';
// import {
//   returnOptions
// } from '@/views/demand/utils/config.js'

export default {
  props: {
    package: {
      type: Object,
      required: true
    },

    updating: {
      type: Boolean,
      required: true
    },

    update: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      fileList: [],
      model: _extends({}, this.package, {
        zip_file: ''
      }),
      creativeProvider: []
    };
  },


  computed: {
    schema: function schema() {
      var h = this.$createElement;

      return {
        type: 'object',
        properties: {
          id: {
            title: 'ID：',
            component: 'plain-text'
          },
          dm_tpl_id: {
            visible: !!(this.model.dm_tpl_id && this.model.dm_tpl_id !== 0),
            title: '创意方向 ID：',
            component: 'plain-text'
          },
          dm_dco_id: {
            visible: !!(this.model.dm_dco_id && this.model.dm_dco_id !== 0),
            title: 'DCO ID：',
            component: 'plain-text',
            tail: {
              render: function render(h) {
                return h(
                  'el-alert',
                  {
                    attrs: {
                      title: '\u8BE5\u57FA\u7840\u5305\u5DF2\u7528\u4E8EDCO\u5236\u4F5C\uFF0C\u66F4\u65B0\u57FA\u7840\u5305\u8BF7\u77E5\u4F1A\u8BBE\u8BA1\u540C\u5B66',
                      type: 'error',
                      closable: false
                    }
                  },
                  []
                );
              }
            }
          },
          zip_file: {
            title: 'zip 包：',
            component: PackageUploader,
            field: {
              drag: true,
              withCredentials: true,
              limit: 1,
              data: {
                md5: 1
              },
              onSuccess: this.onSuccess,
              onChange: this.onChange,
              accept: 'application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream'
            }
          },
          setting: {
            type: 'object',
            title: '基础包配置信息',
            border: false,
            properties: {
              isSupportDco: {
                title: '是否支持 DCO：',
                component: 'radio-group',
                rules: [{
                  required: true,
                  message: '请选择是否支持 DCO',
                  trigger: 'change'
                }],
                field: {
                  options: [{
                    label: '支持',
                    value: 1
                  }, {
                    label: '不支持',
                    value: 2
                  }]
                }
              },
              stage: {
                visible: Number(this.model.setting.isSupportStage) === 1,
                title: '阶段信息:',
                component: 'checkbox-group',
                field: {
                  options: stageOptions
                }
              },
              supported_mw_configs: {
                title: '玩法配置:',
                component: 'checkbox-group',
                field: {
                  options: [{
                    value: 'global_click',
                    label: '全局可点'
                  }, {
                    value: 'auto_click',
                    label: '自动跳转'
                  }, {
                    value: 'yd_click',
                    label: '诱导点击'
                  }]
                }
                // install_return_action: {
                //   title: '安装返回机制', // 策划需求
                //   component: 'select',
                //   field: {
                //     placeholder: '请选择',
                //     clearable: false,
                //     options: returnOptions
                //   }
                // }
              } }
          },
          provider_id: {
            visible: this.model.material_source !== 2, // 只有非自研的素材才允许修改供应商
            title: '制作商',
            component: 'select',
            field: {
              placeholder: '',
              filterable: true,
              clearable: false,
              options: this.creativeProvider
            }
          }
        }
      };
    },
    submitButton: function submitButton() {
      return {
        type: 'primary',
        disabled: this.updating,
        loading: this.updating
      };
    },
    cancelButton: function cancelButton() {
      return {
        disabled: this.updating
      };
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.model = _extends({}, _this.package, {
                zip_file: ''
              });

              _context.next = 3;
              return _this.$store.dispatch('config/getCreativeProvider');

            case 3:
              _this.creativeProvider = _context.sent;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var setting = _extends({}, _this2.model.setting, {
            stage: _this2.model.setting.stage.join(),
            supported_mw_configs: _this2.model.setting.supported_mw_configs.join()
          });
          var params = _extends({}, _.pick(_this2.model, ['id', 'provider_id']), {
            setting: setting
          });

          if (_this2.model.zip_file) params.zip_file = _this2.model.zip_file;

          _this2.$emit('update:updating', true);
          _this2.update(params).then(function () {
            _this2.$emit('update:updating', false);
            _this2.$emit('update-success');
          }).catch(function () {
            _this2.$emit('update:updating', false);
            _this2.$emit('update-fail');
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    onChange: function onChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onSuccess: function onSuccess(res, file, fileList) {
      if (res.code === 0) {
        this.model.zip_file = res.data.file_path;
      } else {
        this.model.zip_file = '';
        this.$message({
          message: res.msg ? res.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
      }
    }
  }
};